import { ChartData } from "../dataset-window/types";
import { IDataSet, PlotDataEx } from "./interfaces";
import { convertKey, convertValue } from "./utils";

export const configScatterChartData = (xData: ChartData, data: ChartData[], selectedColorPalette: Array<string>) => {
  const createPlotData = (d: ChartData, colorHex: string): PlotDataEx => {
    const plotData = {
      name: `${d.title}`,
      type: "scatter",
      mode: "markers",
      showlegend: true,
      unit: d.unit,
      hovertemplate: `<b>%{y:.3f}</b> at %{x} <br> ${d.title}, ${d.unit} at ${xData.title}, ${xData.unit}<extra></extra>`,
      x: xData.valueArr,
      y: d.valueArr,
      opacity: 0.7,
      marker: {
        color: colorHex,
        size: 5,
      },
    } as PlotDataEx;
    return plotData;
  };

  const plotDataArr = data?.reduce((acc: Array< PlotDataEx>, curr: ChartData, index: number) => {
    if (curr !== undefined) {
      acc.push(createPlotData(curr, selectedColorPalette[index]));
    }
    return acc;
  }, []);

  return plotDataArr;
};
